import { combineReducers } from 'redux';

import sidemenu from './sidemenu';
import permission from './permission';

export default combineReducers({
  sidemenu,
  permission,
});
